// AUTOGENERIERT (einmaliger AWC-Abruf) – große europäische Verkehrsflughäfen.
// Diese Liste wird als "Tier 1" der Flughafen-Wetter-Marker verwendet: Diese
// großen Flughäfen werden auf der Radarkarte IMMER angezeigt (in jedem Zoom,
// sofern im Ausschnitt). Kleinere meldende Stationen kommen ab Zoom 9 zusätzlich
// per Live-AWC-Bbox-Abfrage dazu (siehe fetchAirportStationsInArea).
// RN-frei: reine Daten, in client/ und web/ importierbar.

export interface MajorAirport {
  icao: string;
  name: string;
  lat: number;
  lon: number;
}

export const MAJOR_EU_AIRPORTS: MajorAirport[] = [
  { icao: "BIAR", name: "Akureyri Arpt, NE, IS", lat: 65.655, lon: -18.069 },
  { icao: "BIKF", name: "Keflavik Intl, SP, IS", lat: 63.987, lon: -22.614 },
  { icao: "BIRK", name: "Reykjavik Arpt, HO, IS", lat: 64.129, lon: -21.941 },
  { icao: "EBAW", name: "Antwerp Intl, VA, BE", lat: 51.189, lon: 4.46 },
  { icao: "EBBR", name: "Brussels Intl, VL, BE", lat: 50.896, lon: 4.526 },
  { icao: "EBCI", name: "Charleroi Arpt, WH, BE", lat: 50.459, lon: 4.454 },
  { icao: "EBLG", name: "Bierset/Liège Arpt, WL, BE", lat: 50.637, lon: 5.443 },
  { icao: "EBOS", name: "Oostende-Bruges Intl, VH, BE", lat: 51.199, lon: 2.862 },
  { icao: "EDDB", name: "Berlin/Brandenburg Intl, BR, DE", lat: 52.3807, lon: 13.5306 },
  { icao: "EDDC", name: "Dresden Arpt, SN, DE", lat: 51.128, lon: 13.7543 },
  { icao: "EDDE", name: "Erfurt Arpt, TH, DE", lat: 50.983, lon: 10.961 },
  { icao: "EDDF", name: "Frankfurt/Main Arpt, HE, DE", lat: 50.045, lon: 8.598 },
  { icao: "EDDG", name: "Münster/Osnabrück Arpt, NT, DE", lat: 52.135, lon: 7.697 },
  { icao: "EDDH", name: "Hamburg Arpt, HH, DE", lat: 53.633, lon: 9.988 },
  { icao: "EDDK", name: "Koln-Bonn Arpt, NT, DE", lat: 50.865, lon: 7.157 },
  { icao: "EDDL", name: "Düsseldorf Intl, NT, DE", lat: 51.296, lon: 6.769 },
  { icao: "EDDM", name: "Munich Intl, BY, DE", lat: 48.348, lon: 11.813 },
  { icao: "EDDN", name: "Nurnberg Arpt, BY, DE", lat: 49.503, lon: 11.055 },
  { icao: "EDDP", name: "Leipzig/Halle Arpt, SN, DE", lat: 51.435, lon: 12.24 },
  { icao: "EDDR", name: "Saarbrücken Arpt, SL, DE", lat: 49.213, lon: 7.108 },
  { icao: "EDDS", name: "Stuttgart Arpt, BW, DE", lat: 48.69, lon: 9.222 },
  { icao: "EDDV", name: "Hannover Arpt, NI, DE", lat: 52.466, lon: 9.68 },
  { icao: "EDDW", name: "Bremen Arpt, HB, DE", lat: 53.047, lon: 8.787 },
  { icao: "EEKA", name: "Kärdla Arpt, HI, EE", lat: 58.991, lon: 22.831 },
  { icao: "EETN", name: "Tallin Arpt, HA, EE", lat: 59.413, lon: 24.801 },
  { icao: "EFHK", name: "Helsinki/Vantaa Arpt, UU, FI", lat: 60.327, lon: 24.957 },
  { icao: "EFOU", name: "Oulu Arpt, PP, FI", lat: 64.93, lon: 25.355 },
  { icao: "EFRO", name: "Rovaniemi Arpt, LL, FI", lat: 66.562, lon: 25.829 },
  { icao: "EFTU", name: "Turku Arpt, VS, FI", lat: 60.514, lon: 22.263 },
  { icao: "EGAA", name: "Belfast Intl, NI, GB", lat: 54.654, lon: -6.225 },
  { icao: "EGBB", name: "Birmingham Intl, EN, GB", lat: 52.46, lon: -1.758 },
  { icao: "EGCC", name: "Manchester Intl, EN, GB", lat: 53.354, lon: -2.275 },
  { icao: "EGGD", name: "Bristol Intl, EN, GB", lat: 51.383, lon: -2.719 },
  { icao: "EGGW", name: "Luton Arpt, EN, GB", lat: 51.875, lon: -0.368 },
  { icao: "EGHI", name: "Southampton Intl, EN, GB", lat: 50.944, lon: -1.358 },
  { icao: "EGKK", name: "London/Gatwick Arpt, EN, GB", lat: 51.148, lon: -0.19 },
  { icao: "EGLL", name: "London/Heathrow Intl, EN, GB", lat: 51.477, lon: -0.461 },
  { icao: "EGNM", name: "Leeds Bradford Intl, EN, GB", lat: 53.862, lon: -1.665 },
  { icao: "EGNX", name: "Nottingham/E Midlands Arpt, EN, GB", lat: 52.833, lon: -1.333 },
  { icao: "EGPF", name: "Glasgow Arpt, SC, GB", lat: 55.867, lon: -4.433 },
  { icao: "EGPH", name: "Edinburgh Arpt, SC, GB", lat: 55.952, lon: -3.36 },
  { icao: "EGSS", name: "London/Stansted Arpt, EN, GB", lat: 51.881, lon: 0.223 },
  { icao: "EHAM", name: "Amsterdam/Schiphol Arpt, NH, NL", lat: 52.315, lon: 4.79 },
  { icao: "EHBK", name: "Maastricht/Aachen Arpt, LI, NL", lat: 50.905, lon: 5.762 },
  { icao: "EHEH", name: "Eindhoven Arpt, NB, NL", lat: 51.45, lon: 5.377 },
  { icao: "EHGG", name: "Groningen Arpt, DR, NL", lat: 53.12, lon: 6.579 },
  { icao: "EHRD", name: "Rotterdam/The Hague Arpt, ZH, NL", lat: 51.954, lon: 4.444 },
  { icao: "EICK", name: "Cork Arpt, M, IE", lat: 51.848, lon: -8.479 },
  { icao: "EIDW", name: "Dublin Arpt, L, IE", lat: 53.422, lon: -6.298 },
  { icao: "EIKY", name: "Kerry Arpt, KY, IE", lat: 52.18, lon: -9.538 },
  { icao: "EINN", name: "Shannon Arpt, M, IE", lat: 52.702, lon: -8.925 },
  { icao: "EKBI", name: "Billund Arpt, SY, DK", lat: 55.74, lon: 9.152 },
  { icao: "EKCH", name: "Kobenhavn Intl, HO, DK", lat: 55.618, lon: 12.656 },
  { icao: "EKYT", name: "Aalborg Arpt, NO, DK", lat: 57.093, lon: 9.879 },
  { icao: "ELLX", name: "Luxembourg/Findel Arpt, LL, LU", lat: 49.626, lon: 6.204 },
  { icao: "ENBR", name: "Bergen/Flesland Arpt, HO, NO", lat: 60.29, lon: 5.222 },
  { icao: "ENGM", name: "Oslo/Gardermoen Arpt, AK, NO", lat: 60.201, lon: 11.08 },
  { icao: "ENTC", name: "Tromsø Arpt, TR, NO", lat: 69.675, lon: 18.916 },
  { icao: "ENVA", name: "Trondheim Arpt, TR, NO", lat: 63.46, lon: 10.931 },
  { icao: "ENZV", name: "Stavanger/Sola Arpt, RO, NO", lat: 58.884, lon: 5.637 },
  { icao: "EPGD", name: "Gdańsk/Wałęsa Arpt, PM, PL", lat: 54.379, lon: 18.466 },
  { icao: "EPKK", name: "Kraków/Paul II Arpt, ML, PL", lat: 50.078, lon: 19.797 },
  { icao: "EPKT", name: "Katowice/Pyrzowice Arpt, SL, PL", lat: 50.478, lon: 19.085 },
  { icao: "EPPO", name: "Poznań/Ławica Arpt, WP, PL", lat: 52.417, lon: 16.835 },
  { icao: "EPWA", name: "Warsaw/Chopin Arpt, MZ, PL", lat: 52.163, lon: 20.961 },
  { icao: "EPWR", name: "Wrocław/Strachowice Arpt, DO, PL", lat: 51.1032, lon: 16.8998 },
  { icao: "ESGG", name: "Göteborg/Landvetter Arpt, O, SE", lat: 57.667, lon: 12.285 },
  { icao: "ESMS", name: "Malmo/Sturup Arpt, M, SE", lat: 55.539, lon: 13.373 },
  { icao: "ESSA", name: "Stockholm/Arlanda Arpt, AB, SE", lat: 59.664, lon: 17.92 },
  { icao: "ESSB", name: "Stockholm/Bromma Arpt, AB, SE", lat: 59.356, lon: 17.933 },
  { icao: "EVRA", name: "Riga Intl, RG, LV", lat: 56.924, lon: 23.968 },
  { icao: "EYKA", name: "Kaunas Arpt, KI, LT", lat: 54.962, lon: 24.069 },
  { icao: "EYVI", name: "Vilnius Intl, VL, LT", lat: 54.634, lon: 25.286 },
  { icao: "GCFV", name: "Fuerteventura Arpt, CR, ES", lat: 28.445, lon: -13.863 },
  { icao: "GCLP", name: "Grand Canaria Arpt, CR, ES", lat: 27.923, lon: -15.389 },
  { icao: "GCRR", name: "Arrecife/Lanzarote Arpt, CR, ES", lat: 28.952, lon: -13.6 },
  { icao: "GCTS", name: "Tenerife/South Arpt, CR, ES", lat: 28.047, lon: -16.561 },
  { icao: "GCXO", name: "Tenerife/North Arpt, CR, ES", lat: 28.483, lon: -16.342 },
  { icao: "LBBG", name: "Burgas Arpt, BU, BG", lat: 42.569, lon: 27.514 },
  { icao: "LBSF", name: "Sofia Intl, SO, BG", lat: 42.694, lon: 23.414 },
  { icao: "LBWN", name: "Varna Intl, VA, BG", lat: 43.232, lon: 27.825 },
  { icao: "LCLK", name: "Larnaca Intl, LA, CY", lat: 34.874, lon: 33.617 },
  { icao: "LCPH", name: "Paphos Intl, PA, CY", lat: 34.715, lon: 32.479 },
  { icao: "LDDU", name: "Dubrovnik Arpt, DU, HR", lat: 42.56, lon: 18.269 },
  { icao: "LDPL", name: "Pula Arpt, IS, HR", lat: 44.894, lon: 13.922 },
  { icao: "LDSP", name: "Split Arpt, SP, HR", lat: 43.539, lon: 16.301 },
  { icao: "LDZA", name: "Zagreb/Tuđman Intl, ZA, HR", lat: 45.729, lon: 16.054 },
  { icao: "LEAL", name: "Alicante Arpt, VC, ES", lat: 38.282, lon: -0.558 },
  { icao: "LEBB", name: "Bilbao Arpt, PV, ES", lat: 43.298, lon: -2.906 },
  { icao: "LEBL", name: "Barcelona/Prat Arpt, CT, ES", lat: 41.293, lon: 2.07 },
  { icao: "LEIB", name: "Ibiza Arpt, IB, ES", lat: 38.876, lon: 1.384 },
  { icao: "LEMD", name: "Madrid/Barajas Arpt, M, ES", lat: 40.466, lon: -3.555 },
  { icao: "LEMG", name: "Málaga Arpt, AN, ES", lat: 36.666, lon: -4.482 },
  { icao: "LEPA", name: "Palma De Mallorca Arpr, IB, ES", lat: 39.561, lon: 2.737 },
  { icao: "LEST", name: "Santiago Arpt, GA, ES", lat: 42.888, lon: -8.411 },
  { icao: "LEVC", name: "Valencia Arpt, VC, ES", lat: 39.489, lon: -0.482 },
  { icao: "LEZL", name: "Seville/San Pablo Arpt, AN, ES", lat: 37.418, lon: -5.893 },
  { icao: "LFBD", name: "Bordeaux/Mérignac Arpt, NA, FR", lat: 44.831, lon: -0.691 },
  { icao: "LFBO", name: "Toulouse/Blagnac Arpt, OC, FR", lat: 43.621, lon: 1.379 },
  { icao: "LFKF", name: "Figari/Corse Arpt, CO, FR", lat: 41.501, lon: 9.098 },
  { icao: "LFKJ", name: "Ajaccio/Oro Arpt, CO, FR", lat: 41.924, lon: 8.803 },
  { icao: "LFLC", name: "Clermont-Ferrand/Auvergne Arpt, AR, FR", lat: 45.787, lon: 3.169 },
  { icao: "LFLL", name: "Lyon/St-Exupéry Arpt, AR, FR", lat: 45.726, lon: 5.078 },
  { icao: "LFML", name: "Marseille Arpt, PA, FR", lat: 43.438, lon: 5.216 },
  { icao: "LFMN", name: "Nice/Côte d'Azur Arpt, PA, FR", lat: 43.658, lon: 7.216 },
  { icao: "LFMT", name: "Montpellier/Méditerranee Arpt, OC, FR", lat: 43.577, lon: 3.963 },
  { icao: "LFPG", name: "Paris/De Gaulle Arpt, ID, FR", lat: 49.015, lon: 2.534 },
  { icao: "LFPO", name: "Paris/Orly Fld, ID, FR", lat: 48.717, lon: 2.384 },
  { icao: "LFRS", name: "Nantes/Atlantique Arpt, PD, FR", lat: 47.15, lon: -1.609 },
  { icao: "LFSB", name: "Basel/Euro Arpt, GE, FR", lat: 47.614, lon: 7.51 },
  { icao: "LFST", name: "Strasbourg/Entzheim Arpt, PD, FR", lat: 48.549, lon: 7.64 },
  { icao: "LGAV", name: "Athens/Venizelos Intl, I, GR", lat: 37.936, lon: 23.945 },
  { icao: "LGIR", name: "Iraklion Intl, M, GR", lat: 35.337, lon: 25.173 },
  { icao: "LGKO", name: "Kos Arpt, K, GR", lat: 36.801, lon: 27.091 },
  { icao: "LGKR", name: "Corfu/Kapodistinas Arpt, L, GR", lat: 39.61, lon: 19.913 },
  { icao: "LGRP", name: "Rhodes/Diagoras Arpt, K, GR", lat: 36.405, lon: 28.086 },
  { icao: "LGSR", name: "Santorini Isl Arpt, K, GR", lat: 36.399, lon: 25.479 },
  { icao: "LGTS", name: "Thessaloniki Intl, A, GR", lat: 40.52, lon: 22.971 },
  { icao: "LGZA", name: "Zakinthos/Salomos Arpt, J, GR", lat: 37.751, lon: 20.884 },
  { icao: "LHBP", name: "Budapest/Liszt Intl, BU, HU", lat: 47.437, lon: 19.256 },
  { icao: "LHDC", name: "Debrecen Arpt, HL, HU", lat: 47.489, lon: 21.615 },
  { icao: "LIBD", name: "Bari/Palese Arpt, PU, IT", lat: 41.138, lon: 16.765 },
  { icao: "LICA", name: "Lamezia Terme Arpt, CA, IT", lat: 38.908, lon: 16.242 },
  { icao: "LICC", name: "Catania/Fontanarossa Arpt, CT, IT", lat: 37.467, lon: 15.064 },
  { icao: "LICJ", name: "Palermo Arpt, PA, IT", lat: 38.176, lon: 13.091 },
  { icao: "LIEE", name: "Cagliari/Elmas Arpt, CA, IT", lat: 39.243, lon: 9.06 },
  { icao: "LIMC", name: "Milan/Malpensa Arpt, MI, IT", lat: 45.631, lon: 8.728 },
  { icao: "LIME", name: "Milan/Bergamo, BG, IT", lat: 45.674, lon: 9.704 },
  { icao: "LIML", name: "Milan/Linate Arpt, MI, IT", lat: 45.461, lon: 9.263 },
  { icao: "LIPE", name: "Bologna/Marconi Arpt, BO, IT", lat: 44.531, lon: 11.297 },
  { icao: "LIPX", name: "Verona Arpt, TO, IT", lat: 45.387, lon: 10.872 },
  { icao: "LIPZ", name: "Venice/Polo Arpt, VE, IT", lat: 45.505, lon: 12.352 },
  { icao: "LIRA", name: "Rome/Ciampino Arpt, RM, IT", lat: 41.808, lon: 12.585 },
  { icao: "LIRF", name: "Rome/Fiumicino, RM, IT", lat: 41.8, lon: 12.239 },
  { icao: "LIRN", name: "Naples Intl, NA, IT", lat: 40.885, lon: 14.292 },
  { icao: "LIRP", name: "Pisa/Galilei Arpt, PI, IT", lat: 43.684, lon: 10.393 },
  { icao: "LJLJ", name: "Ljubljana/Pucnik Arpt, LJ, SI", lat: 46.218, lon: 14.477 },
  { icao: "LKPR", name: "Prague/Havel Arpt, ST, CZ", lat: 50.101, lon: 14.26 },
  { icao: "LKTB", name: "Brno/Tuřany Arpt, JM, CZ", lat: 49.151, lon: 16.694 },
  { icao: "LMML", name: "Malta Intl, LU, MT", lat: 35.858, lon: 14.477 },
  { icao: "LOWG", name: "Graz Arpt, ST, AT", lat: 46.997, lon: 15.447 },
  { icao: "LOWI", name: "Innsbruck Arpt, TI, AT", lat: 47.26, lon: 11.344 },
  { icao: "LOWK", name: "Klagenfurt Arpt, KA, AT", lat: 46.648, lon: 14.318 },
  { icao: "LOWL", name: "Linz Arpt, OB, AT", lat: 48.233, lon: 14.188 },
  { icao: "LOWS", name: "Salzburg/Mozart Arpt, SA, AT", lat: 47.789, lon: 13.009 },
  { icao: "LOWW", name: "Vienna Intl, NE, AT", lat: 48.117, lon: 16.582 },
  { icao: "LPFR", name: "Faro Arpt, FA, PT", lat: 37.014, lon: -7.966 },
  { icao: "LPMA", name: "Madeira Arpt, MD, PT", lat: 32.698, lon: -16.774 },
  { icao: "LPPR", name: "Porto/Cameriro Arpt, PT, PT", lat: 41.235, lon: -8.684 },
  { icao: "LPPT", name: "Lisbon Arpt, LI, PT", lat: 38.781, lon: -9.136 },
  { icao: "LQMO", name: "Mostar Intl, BI, BA", lat: 43.285, lon: 17.84 },
  { icao: "LQSA", name: "Sarajevo Intl, BI, BA", lat: 43.825, lon: 18.331 },
  { icao: "LRCK", name: "Constanta/Kogălniceanu Arpt, CT, RO", lat: 44.362, lon: 28.488 },
  { icao: "LRCL", name: "Cluj-Napoca Intl, CJ, RO", lat: 46.783, lon: 23.676 },
  { icao: "LROP", name: "Bucharest/Coandă Intl, B, RO", lat: 44.572, lon: 26.102 },
  { icao: "LRTR", name: "Timişoara/Traian Vuia Arpt, SI, RO", lat: 45.811, lon: 21.333 },
  { icao: "LSGG", name: "Geneva/Cointrin Arpt, GE, CH", lat: 46.248, lon: 6.128 },
  { icao: "LSZA", name: "Lugano Arpt, TI, CH", lat: 46.004, lon: 8.91 },
  { icao: "LSZB", name: "Bern Arpt, BE, CH", lat: 46.914, lon: 7.497 },
  { icao: "LSZH", name: "Zürich Intl Arpt, ZH, CH", lat: 47.48, lon: 8.536 },
  { icao: "LTAC", name: "Ankara/Esenboğa Intl, AN, TR", lat: 40.128, lon: 32.995 },
  { icao: "LTAF", name: "Adana Arpt, AD, TR", lat: 36.989, lon: 35.293 },
  { icao: "LTAI", name: "Antalya Arpt, AN, TR", lat: 36.9, lon: 30.798 },
  { icao: "LTBA", name: "Istanbul/Ataturk Intl, IS, TR", lat: 40.982, lon: 28.821 },
  { icao: "LTBJ", name: "Izmir/Menderes Arpt, IZ, TR", lat: 38.285, lon: 27.155 },
  { icao: "LTFJ", name: "Istanbul/Gokcen Intl, KO, TR", lat: 40.899, lon: 29.309 },
  { icao: "LTFM", name: "Istanbul Arpt, IS, TR", lat: 41.262, lon: 28.74 },
  { icao: "LWOH", name: "Ohrid Arpt, DB, MK", lat: 41.181, lon: 20.744 },
  { icao: "LWSK", name: "Skopje Intl, IL, MK", lat: 41.952, lon: 21.627 },
  { icao: "LYBE", name: "Belgrade/Tesla Arpt, BE, RS", lat: 44.824, lon: 20.291 },
  { icao: "LYNI", name: "Niš Arpt, NI, RS", lat: 43.338, lon: 21.863 },
  { icao: "LYPG", name: "Podgorica Arpt, PO, ME", lat: 42.359, lon: 19.252 },
  { icao: "LYTV", name: "Tivat Arpt, TI, ME", lat: 42.405, lon: 18.723 },
  { icao: "LZIB", name: "Bratislava/Ivanka Arpt, BL, SK", lat: 48.17, lon: 17.207 },
  { icao: "LZKZ", name: "Košice Intl, KI, SK", lat: 48.661, lon: 21.24 },
];

const MAJOR_ICAO_SET = new Set(MAJOR_EU_AIRPORTS.map((a) => a.icao));

/** True, wenn der ICAO-Code zu einem großen (immer sichtbaren) Flughafen gehört. */
export function isMajorAirport(icao: string): boolean {
  return MAJOR_ICAO_SET.has(icao.trim().toUpperCase());
}
